import axios from 'axios';
import React, { Component } from "react";
import { deleteTeam } from '../services/userServices';
import { setEventId } from '../services/storeIdServices';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close'

import { IconButton, } from '@material-ui/core'
import '../App.css'

import { Card } from "@material-ui/core"
import history from '../history';
import { MenuItem } from '@material-ui/core'
import Button from '@material-ui/core/Button'

import Dialog from '@material-ui/core/Dialog'

import DialogTitle from '@material-ui/core/DialogTitle'

import DialogContent from '@material-ui/core/DialogContent'

import DialogActions from '@material-ui/core/DialogActions'
// import { Link } from 'react-router';
// import EditPage from "../screens/EditPage";

// import CardActions from '@material-ui/core/CardActions';
// import Button from '@material-ui/core/Button';

export default class CardComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            click: false,
            // showEdit:false,
            trash: false,
            teamName: '',
            fetchData: {}

        }
        // this.data = this.data.bind(this);


        // this.handleTrash = this.handleTrash.bind(this)
        this.handleOpenDialog = this.handleOpenDialog.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.mouseLeave = this.mouseLeave.bind(this);
    }
    data = (e) => {
        if (e.target.id) {
            history.push('/editTeamPage', e.target.id)
            // this.props.history.push('/editPage', { Display: this.props.Display, noteKey: this.props.noteKey })

            this.props.navigation.navigate("/editTeamPage"); // e.target.id

        }


        // console.log("display data" + this.props.Display)
        // this.props.history.push('/editPage', { Display: this.props.Display, noteKey: this.props.noteKey })


    }



    editClick = event => {
        try {
            event.preventDefault();
            this.props.history.push("/register");
        } catch (err) {
            console.log("error");
        }
    };







    // trash = e => {
    //     try {
    //         e.preventDefault();
    //         this.props.props.history.push("/trash");
    //     } catch (err) {
    //         console.log("error at deleting in display events");
    //     }
    // };
    trash = () => {

        var data = this.props.Display.id

        deleteTeam(data)
            .then((response) => {
                axios.get('http://localhost:5000/refresh')
              .then(function (response) {
                // handle success
                console.log("Updated Sucessfullyyyyyyyyyyyyyyyyy");
              })
              .catch(function (error) {
                // handle error
                console.log(error);
              })
              .finally(function () {
                // always executed
              });
                setTimeout(() => {
                    this.setState({
                        fetchData: response,
                        openSnackBar: true,
                        snackBarMessage: "Deleted Successfully"
                    });
                    window.location.href = "/teamsScreen"
                }, 500);
              
                
                console.log("fetchEvent", this.state.fetchEvent);
            })
            .catch((error) => {
                console.log(error);
            });
        // deleteEvent(data.id)
        //     .then((result) => {
        //         setTimeout(() => {
        //             this.setState({
        //                 fetchdata: result,
        //                 openSnackBar: true,
        //                 snackBarMessage: "Deleted Successfully"
        //             });
        //         }, 500);
        //         this.props.history.push('/eventScreen')
        //     })
        //     .catch((err)=>{
        //         console.log(err,"error deleting file");

        //     })
    }









    // handleTrash = async event =>{
    //     console.log("trashBefore===>",this.trash);

    //     //  await this.setState({
    //     //     trash: !this.state.trash
    //     // })
    //     // console.log("trash value after",this.trash );
    //     // // this.props.trash(this.state.trash)
    //     // // this.props.navigation.navigate('Trash')
    //     // this.props.props.push("/login")

    // }


    handleOpenDialog() {
        this.setState({
            openDialog: true
        });
    }

    handleCloseDialog() {
        this.setState({
            openDialog: false
        });
    }
    mouseLeave() {
        var data = this.props.Display.id;
        setEventId(data)
        window.href="/editTeamPage";
    }
    


    render() {




        return (
            <div onClick={this.data.bind(this)} location={this.props.location} >
                <a className="navigation-link" href={`/eventScreen?team=${this.props.Display.eventTeamName}&id=${this.props.Display.id}`}>
                <Card className="myCardClass">
                   {/* onPress={this.data.bind(this)}           */}
                    <div>


                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'left' , paddingLeft:'2%'}}>


                        <div style={{ fontSize: 25, color: 'black' }}>
                                
                                <p className="alignment">{this.props.Display.eventTeamName}</p>
                            </div>
                            

                        </div>


                        <div style={{ fontSize: 22, color: 'black', textAlign: 'center' }}>
                            <span className="DisplayInlineDate">{this.props.Display.eventDate}</span>
                            {/* <p>Today</p> */}
                           <span className="DisplayInlineTime">{this.props.Display.eventTime}</span>
                            {/* <p>eventTime</p> */}
                        </div>


                        {/* <div style={{ fontSize: 25, fontWeight: 'bold', color: 'black', textAlign: 'center' }} >
                            <p>File Name</p>
                        </div> */}

                    </div>
                </Card>
                </a>
                {/* <Card style={{ borderWidth: '20%', borderColor: 'blue', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '10%' }} */}
                
                <div className="Icons">

                            {/* <MenuItem
                                id="sideMenu"
                                // onClick={this.editClick()}
                                onClick={this.data.bind(this)}
                                onClick={(event) => this.editClick(event)}
                            >
                                <img
                                    src={require('../assets/edit-24px.svg')}
                                    alt='EditIcon'
                                    id="NavButton"
                                />
                            </MenuItem> */}



                            {/* <MenuItem
                                id="sideMenu"
                                // trash={this.handleTrash.bind(this)}>
                                onClick={this.data.bind(this)}
                                onClick={this.trash}
                            >
                                <img
                                    src={require('../assets/delete-24px.svg')}
                                    alt='DeleteIcon'
                                    id="NavButton"
                                />
                            </MenuItem> */}





                            <div>
                                    <a className="navigation-link"
                                        href="/editTeamPage">
                                        <img
                                            src={require('../assets/edit-24px.svg')}
                                            alt='EditIcon'
                                            id={this.props.Display.id}
                                            title='Click to Edit'
                                            onMouseDown={this.mouseLeave}
                                        />
                                    </a>
                                <button className="eraseDefault" colored onClick={this.handleOpenDialog} raised ripple>
                                  
                                        <img
                                            src={require('../assets/delete-24px.svg')}
                                            alt='DeleteIcon'
                                            id=""
                                            title='Click to delete'
                                        />

                                </button>

                                <Dialog open={this.state.openDialog} onCancel={this.handleCloseDialog}>
                                    <DialogTitle>Delete??</DialogTitle>
                                    <DialogContent>
                                        <p>  Are you sure you want to delete this item </p>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button type="button"
                                            color='secondary'
                                            onClick={this.trash}>
                                            Delete
                                        </Button>
                                        <Button type="button" color='primary' onClick={this.handleCloseDialog}>
                                            Cancel
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </div>

                            {/* <div>
                                <MenuItem
                                    id={this.props.Display.id}>
                                    <a className="navigation-link"
                                        href="/login">
                                        <img
                                            src={require('../assets/delete-24px.svg')}
                                            alt='DeleteIcon'
                                            id={this.props.Display.id}
                                            title='Click to Delete'
                                        />
                                    </a>
                                </MenuItem>
                            </div> */}









                        </div>
                <Snackbar
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "left"
                    }}
                    open={this.state.openSnackBar}
                    autoHideDuration={6000}
                    onClose={this.handleSnackClose}
                    variant="error"
                    ContentProps={{
                        "aria-describedby": "message-id"
                    }}
                    message={<span id="message-id"> {this.state.snackBarMessage} </span>}
                    action={[
                        <div>
                            <IconButton
                                key="close"
                                aria-label="Close"
                                onClick={this.handleSnackClose}
                            >
                                <CloseIcon />
                            </IconButton>
                        </div>
                    ]}
                />
            </div>
        )
    }
}



